export const usersEn = {
  //BEGIN MICHAEL
  USER: 'User',
  USERS: 'Users',
  //END MICHAEL
}

export const usersEs: typeof usersEn = {
  //BEGIN MICHAEL
  USER: 'Usuario',
  USERS: 'Usuarios',
  //END MICHAEL
}
